function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Divider } from 'antd';
import { ReactComponent as EnterSvg } from "../../../../../assets/svg/enter.svg";
import cls from 'classnames';
import { forwardRef } from 'react';
import styles from "./index.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ListItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var data = props.data,
    index = props.index,
    selectedItem = props.selectedItem,
    handleClick = props.handleClick,
    searchText = props.searchText;
  var _data$item = data.item,
    flowOrderName = _data$item.flowOrderName,
    flowName = _data$item.flowName,
    willTimeout = _data$item.willTimeout,
    taskOrderId = _data$item.taskOrderId,
    flowOrderId = _data$item.flowOrderId,
    completeTime = _data$item.completeTime,
    timeoutDuration = _data$item.timeoutDuration,
    applyTimeDuration = _data$item.applyTimeDuration,
    applyTime = _data$item.applyTime,
    deadlineTime = _data$item.deadlineTime,
    nodeName = _data$item.nodeName,
    taskNodeItems = _data$item.taskNodeItems,
    rebutTag = _data$item.rebutTag;
  var flowOrdName = flowOrderName || '';
  var title = flowName ? "\u3010".concat(flowName, "\u3011").concat(flowOrdName) : flowOrdName;
  var openTaskDetail = function openTaskDetail() {
    handleClick(taskOrderId, flowOrderId);
  };
  var highlightspan = function highlightspan(span) {
    var regex = new RegExp("(".concat(searchText, ")"), 'gi');
    return span.split(regex).map(function (part, index) {
      return part === searchText ? /*#__PURE__*/_jsx("span", {
        style: {
          color: '#4C65ED'
        },
        children: part
      }, "".concat(part, "-").concat(index)) : /*#__PURE__*/_jsx("span", {
        children: part
      }, "".concat(part, "-").concat(index));
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: cls(styles.prefixCls),
    ref: ref,
    children: /*#__PURE__*/_jsxs("div", {
      className: cls(styles.listItem, _defineProperty({}, styles.selectedItem, selectedItem === index)),
      onClick: openTaskDetail,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.listItemContent,
        children: [/*#__PURE__*/_jsx("h2", {
          className: styles.listTitle,
          children: highlightspan(title)
        }), /*#__PURE__*/_jsx("div", {
          className: styles.listSubTitle,
          children: nodeName
        }), /*#__PURE__*/_jsx("div", {
          className: styles.subtitle,
          children: flowOrderId
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.flowItem,
          children: [applyTime ? /*#__PURE__*/_jsxs("span", {
            className: styles.subLabel,
            children: [applyTime, " \u53D1\u8D77"]
          }) : null, applyTimeDuration ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [applyTimeDuration ? /*#__PURE__*/_jsx(Divider, {
              type: "vertical"
            }) : null, /*#__PURE__*/_jsx("span", {
              className: styles.subLabel,
              children: applyTimeDuration
            })]
          }) : null, completeTime ? /*#__PURE__*/_jsx("span", {
            className: styles.subLabel,
            children: completeTime
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.subLabel,
              children: deadlineTime
            }), willTimeout ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Divider, {
                type: "vertical"
              }), /*#__PURE__*/_jsx("span", {
                className: styles.timeoutTag,
                children: "\u5373\u5C06\u8D85\u65F6"
              })]
            }) : null, timeoutDuration ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [timeoutDuration ? /*#__PURE__*/_jsx(Divider, {
                type: "vertical"
              }) : null, /*#__PURE__*/_jsx("span", {
                className: styles.timeoutTagTwo,
                children: timeoutDuration
              })]
            }) : null]
          }), rebutTag ? /*#__PURE__*/_jsx("div", {
            className: styles.help,
            children: /*#__PURE__*/_jsx("div", {
              className: styles.warnTag,
              children: rebutTag
            })
          }) : null]
        }), taskNodeItems !== null && taskNodeItems !== void 0 && taskNodeItems.length ? /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.nodeList,
            children: [taskNodeItems.slice(0, 2).map(function (item) {
              var nodeId = item.nodeId,
                nodeName = item.nodeName,
                timeoutDuration = item.timeoutDuration,
                willTimeout = item.willTimeout,
                handlers = item.handlers;
              var handlerList = handlers.filter(function (h) {
                return !!h;
              });
              var handlerSpan = '处理中';
              if (handlerList.length > 2) {
                handlerSpan = handlerList.slice(0, 2).map(function (h) {
                  return "".concat(h.userName);
                }).join('、') + " \u7B49".concat(handlerList.length, "\u4EBA\u5904\u7406\u4E2D");
              } else {
                handlerSpan = (handlerList === null || handlerList === void 0 ? void 0 : handlerList.map(function (h) {
                  return "".concat(h.userName);
                }).join('、')) + ' 处理中';
              }
              return /*#__PURE__*/_jsxs("div", {
                className: styles.nodeItem,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.name,
                  children: nodeName
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.help,
                  children: [/*#__PURE__*/_jsx("span", {
                    className: styles.helpText,
                    children: handlerSpan
                  }), willTimeout ? /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx("div", {
                      className: styles.split
                    }), /*#__PURE__*/_jsx("span", {
                      className: styles.warnText,
                      children: "\u5373\u5C06\u8D85\u65F6"
                    })]
                  }) : null, timeoutDuration ? /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsx("div", {
                      className: styles.split
                    }), /*#__PURE__*/_jsx("span", {
                      className: styles.dangerText,
                      children: timeoutDuration
                    })]
                  }) : null]
                })]
              }, nodeId);
            }), taskNodeItems.length > 2 ? /*#__PURE__*/_jsx("div", {
              className: styles.help,
              children: /*#__PURE__*/_jsxs("span", {
                className: styles.helpText,
                children: ["\u5F53\u524D\u5171 ", taskNodeItems.length, " \u4E2A\u8282\u70B9\u8FDB\u884C\u4E2D..."]
              })
            }) : null]
          })
        }) : null]
      }), selectedItem === index ? /*#__PURE__*/_jsx("div", {
        className: styles.icon,
        children: /*#__PURE__*/_jsx(EnterSvg, {})
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })
  });
});
export default ListItem;